import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { RefreshCw, Database, TrendingUp, Zap } from 'lucide-react';
interface SlideStrategyProps {
  onContinue: () => void;
}
export function SlideStrategy({
  onContinue
}: SlideStrategyProps) {
  const [stage, setStage] = useState(-1);
  const pillars = [{
    icon: <Database className="w-6 h-6" data-id="element-573" />,
    title: 'Leverage Existing Assets',
    desc: 'No new content creation required. We repurpose existing approved materials into interactive formats.'
  }, {
    icon: <Zap className="w-6 h-6" data-id="element-574" />,
    title: 'Rapid Deployment',
    desc: 'Centralized creation with localized deployment. Weeks to launch, not months.'
  }, {
    icon: <TrendingUp className="w-6 h-6" data-id="element-575" />,
    title: 'Behavioral Data Capture',
    desc: 'Move beyond vanity metrics to understand what drives HCP decisions and knowledge gaps.'
  }, {
    icon: <RefreshCw className="w-6 h-6" data-id="element-576" />,
    title: 'Continuous Optimization',
    desc: 'A closed-loop system where every interaction informs and improves the next campaign.'
  }];
  useEffect(() => {
    const timers = pillars.map((_, idx) => setTimeout(() => setStage(idx), 500 + idx * 400));
    return () => timers.forEach(clearTimeout);
  }, []);
  return <div className="h-full w-full flex flex-col px-12 py-16 md:px-24 md:py-20 max-w-7xl mx-auto" data-id="element-577">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-16 text-center" data-id="element-578">
        The Operating Model
      </motion.h2>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-8 items-center justify-center max-w-5xl mx-auto w-full" data-id="element-579">
        {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= idx ? 1 : 0,
        y: stage >= idx ? 0 : 20
      }} className="bg-navy-700/40 border border-navy-600 p-8 rounded-2xl h-full flex flex-col" data-id="element-580">
            <div className="w-12 h-12 rounded-xl bg-teal-400/10 text-teal-400 flex items-center justify-center mb-6" data-id="element-581">
              {pillar.icon}
            </div>
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-582">
              {pillar.title}
            </h3>
            <p className="text-white/60 leading-relaxed flex-1" data-id="element-583">
              {pillar.desc}
            </p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 3 ? 1 : 0
    }} className="mt-12 flex justify-end" data-id="element-584">
        <Button onClick={onContinue} data-id="element-585">What Snakker Does</Button>
      </motion.div>
    </div>;
}